import * as React from 'react';
import PropTypes from 'prop-types';
import ol_Map from 'ol/Map';
import ol_control_OverviewMap from 'ol/control/OverviewMap';
import { Util } from '../util';
import Map from '../map';

export class OverviewMap extends React.Component {
    constructor(props) {
        super(props);
        this.options = {
            collapsed: undefined,
            collapseLabel: undefined,
            collapsible: undefined,
            label: undefined,
            layers: undefined,
            render: undefined,
            target: undefined,
            tipLabel: undefined,
            view: undefined
        };
        this.events = {
            'change': undefined,
            'propertychange': undefined
        };
    }
    render() { return null; }
    componentDidMount() {
        let options = Util.getOptions(Object['assign'](this.options, this.props));
        this.control = new ol_control_OverviewMap(options);
        this.context.mapComp.controls.push(this.control);
        let olEvents = Util.getEvents(this.events, this.props);
        for (let eventName in olEvents) {
            this.control.on(eventName, olEvents[eventName]);
        }
    }
}
OverviewMap['contextTypes'] = {
    mapComp: PropTypes.instanceOf(Map),
    map: PropTypes.instanceOf(ol_Map)
};